import * as React from "react";
import Hexagon from "../images/home/hexagons/HexagonStandard.svg";
import { CGI_GRADIENT_A_45DEG } from "../helpers/enums";
import { Box, Typography } from "@mui/material";

export default function CategoryHexagon({ category }) {
  return (
    <Box
      sx={{
        background: `url(${Hexagon})`,
        width: { xs: 100, md: 225 },
        height: { xs: 100, md: 225 },
        backgroundSize: "contain",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        align="center"
        sx={{
          background: CGI_GRADIENT_A_45DEG,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontSize: { xs: 10.5, md: 22 },
          userSelect: "none",
          width: { xs: 70, md: 140 },
        }}
      >
        {category}
      </Typography>
    </Box>
  );
}
